/* eslint-disable complexity */
/* eslint-disable no-console */
/* eslint-disable no-use-before-define */

import localeUtils from 'utils/LanguageLocale';
import EN from 'components/Catalog/UpperFunnel/locales/UpperFunnelFilters_en_US.js';
import FR from 'components/Catalog/UpperFunnel/locales/UpperFunnelFilters_fr_CA.js';
const getText = localeUtils.getLocalisedDataFromResource(EN, FR);
import catalogUtils from 'utils/Catalog';
import storeUtils from 'utils/Store';
import userActions from 'actions/UserActions';
import store from 'store/Store';
import actions from 'Actions';
import addressUtils from 'utils/Address';
import helpersUtils from 'utils/Helpers';
import deliveryOptionsUtils from 'utils/DeliveryOptions';
import sysUtils from 'utils/ShopYourStore';
import StringUtils from 'utils/String';
import {
    PICKUP,
    SAME_DAY,
    SHIP_TO_HOME,
    PICKUP_FILTER_START,
    SAME_DAY_FILTER_START,
    SHIP_TO_HOME_FILTER_START,
    PICKUP_ARIA_DESCRIBED_BY,
    SAME_DAY_ARIA_DESCRIBED_BY,
    SHIP_TO_HOME_ARIA_DESCRIBED_BY
} from 'constants/UpperFunnel';
import { REFINEMENT_TYPES } from '@ufe/shared/constants/catalog';
const { CHECKBOXES_WITH_DROPDOWN } = REFINEMENT_TYPES;

import taskQueueUtils from 'utils/TaskQueue';

const { deferTaskExecution } = helpersUtils;
const { isNDDNewDeliveryName } = deliveryOptionsUtils;
const upperFunnelQueue = taskQueueUtils.createTaskQueue();

const PICKUP_STORE_LABEL_MAX_LENGTH_WITHOUT_NEARBY = 20;
const PICKUP_STORE_LABEL_MAX_LENGTH_WITH_NEARBY = 10;
const PICKUP_STORE_RENAME_PLACEHOLDER = '{0}';

const filterParamsStart = {
    [PICKUP]: PICKUP_FILTER_START,
    [SAME_DAY]: SAME_DAY_FILTER_START,
    [SHIP_TO_HOME]: SHIP_TO_HOME_FILTER_START
};

let isMegaFilterOpen = false;

function updateFiltersModalState(open, discardDraft = false) {
    if (discardDraft) {
        upperFunnelQueue.clear();
        store.dispatch(userActions.clearUpperFunnelDraft());
    }

    isMegaFilterOpen = open;
}

function updateZipCodeInOtherFilter(filterKey, filterVal, currentSelected) {
    const selectionArray = currentSelected;

    if (filterKey === SHIP_TO_HOME || filterKey === SAME_DAY) {
        const filterIndex = selectionArray.findIndex(selectedFilter => selectedFilter.includes(filterKey === SHIP_TO_HOME ? SAME_DAY : SHIP_TO_HOME));

        if (filterIndex > -1) {
            selectionArray[filterIndex] = filterKey === SHIP_TO_HOME ? getSameDayDeliveryFilterValue(filterVal) : getShipToHomeFilterValue(filterVal);
        }
    }

    return selectionArray;
}

function combineWithActiveFilters(title, selectedFilters, filterValue) {
    const filterKey = filterValue.split('=')[0];
    const filterVal = filterValue.split('=')[1];

    const currentSelected = updateZipCodeInOtherFilter(filterKey, filterVal, [...selectedFilters[title]]);
    // Delete duplicates
    const duplicateIdx = currentSelected.findIndex(value => value.startsWith(filterKey));

    if (duplicateIdx >= 0) {
        currentSelected.splice(duplicateIdx, 1);
    }

    const result = [...currentSelected, filterValue];

    return result;
}

function getUpperFunnelFilterValueStart(key) {
    return filterParamsStart[key] || '';
}

function getPickupFilterValue(storeId) {
    if (!storeId) {
        return '';
    }

    const filterStart = getUpperFunnelFilterValueStart(PICKUP);

    return `${filterStart}=${storeId || ''}`;
}

function getUpperFunnelFiltersName(refinements) {
    const result = refinements.find(refinement => refinement.type === CHECKBOXES_WITH_DROPDOWN);

    return result?.displayName;
}

function getMultiStorePickupLabel(fullStoreNameText, chicletDisplayName) {
    const { nearbyStoresEnabled, includeNearbyStores } = sysUtils.getMultiStoreFilteringQueryParams();

    if (!nearbyStoresEnabled || !chicletDisplayName || !fullStoreNameText) {
        return null;
    }

    const maxLength = includeNearbyStores ? PICKUP_STORE_LABEL_MAX_LENGTH_WITH_NEARBY : PICKUP_STORE_LABEL_MAX_LENGTH_WITHOUT_NEARBY;
    const truncated = helpersUtils.truncateText(fullStoreNameText, maxLength);

    return chicletDisplayName.replace(PICKUP_STORE_RENAME_PLACEHOLDER, truncated);
}

function getSameDayDeliveryFilterValue(zipCode) {
    if (!zipCode) {
        return '';
    }

    const filterStart = getUpperFunnelFilterValueStart(SAME_DAY);

    return `${filterStart}=${zipCode}`;
}

function getShipToHomeFilterValue(zipCode) {
    if (!zipCode) {
        return '';
    }

    const filterStart = getUpperFunnelFilterValueStart(SHIP_TO_HOME);

    return `${filterStart}=${zipCode}`;
}

function selectFilters(originalSelectFilters, selectedFilters, title, filterValue) {
    const nextFilterValues = combineWithActiveFilters(title, selectedFilters, filterValue);
    const applyFilters = !isMegaFilterOpen;
    originalSelectFilters({ [title]: nextFilterValues }, applyFilters);
}

function showStoreSwitcherModal(event, options) {
    event?.preventDefault();
    event?.stopPropagation();

    deferTaskExecution(() => {
        const {
            originalSelectFilters, selectedFilters, title, entry, ...restOptions
        } = options;

        const storeSwitcherOptions = {
            isUpperFunnel: true,
            ...(isMegaFilterOpen && { taskQueue: upperFunnelQueue }),
            ...(restOptions && (restOptions || {}))
        };

        function callback(argumentsObj) {
            const filterValue = getPickupFilterValue(argumentsObj?.storeId);
            selectFilters(originalSelectFilters, selectedFilters, title, filterValue);
        }

        store.dispatch(
            actions.showStoreSwitcherModal({
                isOpen: true,
                options: storeSwitcherOptions,
                entry: entry || 'filter menu',
                afterCallback: callback,
                showNearbyStoresToggle: true
            })
        );
    });
}

function showZipCodeModal(event, options, isSdd) {
    event?.preventDefault();
    event?.stopPropagation();

    deferTaskExecution(() => {
        const { originalSelectFilters, selectedFilters, title, entry } = options;

        function callback(argumentsObj) {
            const filterValue = isSdd
                ? getSameDayDeliveryFilterValue(argumentsObj?.zipCode || argumentsObj?.postalCode)
                : getShipToHomeFilterValue(argumentsObj?.zipCode || argumentsObj?.postalCode);
            selectFilters(originalSelectFilters, selectedFilters, title, filterValue);
        }

        const zipCodeModalOptions = { isSdd: isSdd, ...(isMegaFilterOpen && { taskQueue: upperFunnelQueue }) };

        store.dispatch(
            actions.showShippingDeliveryLocationModal({
                isOpen: true,
                entry: entry ? `${entry} sdd` : 'filter menu sdd',
                callback: callback,
                options: zipCodeModalOptions
            })
        );
    });
}

function upperFunnelCheckboxClick(event, options) {
    const {
        title, filterVal, originalRemoveFilterValue, selectedFilters, originalSelectFilters, isSelected
    } = options;

    if (isSelected) {
        originalRemoveFilterValue(title, filterVal, true);
    } else {
        selectFilters(originalSelectFilters, selectedFilters, title, filterVal);
    }
}

function removeShipToHomeFilter(refinementValues) {
    return refinementValues.filter(val => !(val.refinementStringValueId || val.refinementValue || '').startsWith(SHIP_TO_HOME_FILTER_START));
}

function enhanceValues(data = [], enhancedComponentProps = {}) {
    /* eslint-disable complexity */
    const {
        deliveryOptions,
        preferredStore,
        user,
        selectFilters: originalSelectFilters,
        selectedFilters,
        removeFilterValue: originalRemoveFilterValue,
        showEddOnBrowseAndSearch,
        bypassShowEddOnBrowseAndSearchAbTest = false
    } = enhancedComponentProps;

    const deliveryOptionsStoreId = deliveryOptions?.pickup?.pickupStoreId;
    const deliveryOptionsStoreName = (deliveryOptions?.pickup?.pickupStoreName.split(':')[1] || '').trim();
    const deliveryOptionsZipCode = deliveryOptions?.sameDay?.sameDayZipCode || deliveryOptions?.shipToHome?.shipToHomeZipCode;
    const upperFunnelName = getUpperFunnelFiltersName(data);
    const draftStoreName = preferredStore?.preferredStoreInfo?.draft?.displayName;
    const draftStoreId = preferredStore?.preferredStoreInfo?.draft?.storeId;
    const draftZipCode = addressUtils.formatZipCode(user?.draft?.preferredZipCode);
    const storeNameText = draftStoreName || preferredStore?.preferredStoreName || deliveryOptionsStoreName || getText('chooseStore');
    const userZipCode = addressUtils.formatZipCode(user?.preferredZipCode);
    const zipCodeText = draftZipCode || userZipCode || getText('setYourLocation');
    const shouldShowShipToHome = showEddOnBrowseAndSearch || bypassShowEddOnBrowseAndSearchAbTest;
    const pickupUpperFunnelFilterValue = getPickupFilterValue(draftStoreId || deliveryOptionsStoreId || preferredStore?.preferredStoreInfo?.storeId);
    const sameDayDeliveryFilterValue = getSameDayDeliveryFilterValue(draftZipCode || deliveryOptionsZipCode || userZipCode);
    const shipToHomeFilterValue = shouldShowShipToHome ? getShipToHomeFilterValue(draftZipCode || deliveryOptionsZipCode || userZipCode) : '';
    const isBopisable = preferredStore?.preferredStoreInfo?.isBopisable;
    const isSameDayFilterSelected = selectedFilters && catalogUtils.isFilterSelected(selectedFilters, SAME_DAY_FILTER_START);
    const isPickupFilterSelected = selectedFilters && catalogUtils.isFilterSelected(selectedFilters, PICKUP_FILTER_START);
    const isShipToHomeFilterSelected = selectedFilters && catalogUtils.isFilterSelected(selectedFilters, SHIP_TO_HOME_FILTER_START);

    const pickupModalTrigger = (e, entry) =>
        showStoreSwitcherModal(e, {
            entry,
            originalSelectFilters,
            selectedFilters,
            title: upperFunnelName
        });

    const pickupCheckboxTrigger = (
        e // in store button click
    ) =>
        deferTaskExecution(() =>
            upperFunnelCheckboxClick(e, {
                originalSelectFilters,
                selectedFilters,
                title: upperFunnelName,
                filterVal: pickupUpperFunnelFilterValue,
                originalRemoveFilterValue,
                isSelected: isPickupFilterSelected
            })
        );

    const sddModalTrigger = (e, entry) =>
        showZipCodeModal(
            e,
            {
                entry,
                originalSelectFilters,
                selectedFilters,
                title: upperFunnelName
            },
            true
        );

    const shipToHomeModalTrigger = (e, entry) =>
        showZipCodeModal(
            e,
            {
                entry,
                originalSelectFilters,
                selectedFilters,
                title: upperFunnelName
            },
            false
        );

    const sameDayCheckboxTrigger = e =>
        deferTaskExecution(() =>
            upperFunnelCheckboxClick(e, {
                originalSelectFilters,
                selectedFilters,
                title: upperFunnelName,
                filterVal: sameDayDeliveryFilterValue,
                originalRemoveFilterValue,
                isSelected: isSameDayFilterSelected
            })
        );

    const shipToHomeCheckboxTrigger = e =>
        deferTaskExecution(() =>
            upperFunnelCheckboxClick(e, {
                originalSelectFilters,
                selectedFilters,
                title: upperFunnelName,
                filterVal: shipToHomeFilterValue,
                originalRemoveFilterValue,
                isSelected: isShipToHomeFilterSelected
            })
        );

    function upperFunnelFiltersConfig(value) {
        const fullStoreNameText = storeUtils.addSephoraAtStart(storeNameText);
        const { nearbyStoresEnabled } = sysUtils.getMultiStoreFilteringQueryParams();
        const describedByCompData = { zipCodeText, storeNameText, showEddOnBrowseAndSearch };
        const fastDeliveryText = getText('fastDelivery');
        const getNewDeliveryNameText = oldName => (isNDDNewDeliveryName() ? fastDeliveryText : oldName);
        const multiStorePickupLabel = getMultiStorePickupLabel(fullStoreNameText, value.chicletDisplayName);
        const multiStorePickupOverrides = multiStorePickupLabel && {
            chicletDisplayName: multiStorePickupLabel,
            refinementValueSpecificDisplayName: ''
        };

        const upperFunnelFiltersConfigProperties = {
            [PICKUP_FILTER_START]: {
                filterKey: PICKUP_FILTER_START,
                refinementValue: pickupUpperFunnelFilterValue,
                refinementValueDisplayNameComp: PICKUP,
                fullStoreNameText,
                nearbyStoresEnabled,
                refinementDisplayNameAndValue: nearbyStoresEnabled
                    ? StringUtils.format(value.refinementValueDisplayName ?? '', helpersUtils.truncateText(fullStoreNameText))
                    : `${value.refinementValueDisplayName}: ${helpersUtils.truncateText(fullStoreNameText)}`,
                refinementValueSpecificDisplayName: helpersUtils.truncateText(fullStoreNameText),
                checkboxClick: isBopisable ? null : pickupModalTrigger,
                labelClick: pickupModalTrigger,
                pillClick: isBopisable ? pickupCheckboxTrigger : pickupModalTrigger,
                isSelected: isPickupFilterSelected,
                describedById: PICKUP_ARIA_DESCRIBED_BY,
                describedByCompData,
                ...multiStorePickupOverrides
            },
            [SAME_DAY_FILTER_START]: {
                filterKey: SAME_DAY_FILTER_START,
                refinementValue: sameDayDeliveryFilterValue,
                refinementValueDisplayNameComp: SAME_DAY,
                refinementValueDisplayName: getNewDeliveryNameText(value.refinementValueDisplayName),
                chicletDisplayName: getNewDeliveryNameText(value.refinementValueDisplayName),
                refinementDisplayNameAndValue: `${getNewDeliveryNameText(value.refinementValueDisplayName)}: ${zipCodeText}`,
                refinementValueSpecificDisplayName: zipCodeText,
                checkboxClick: userZipCode ? null : sddModalTrigger,
                labelClick: sddModalTrigger,
                pillClick: userZipCode ? sameDayCheckboxTrigger : sddModalTrigger,
                isSelected: isSameDayFilterSelected,
                describedById: SAME_DAY_ARIA_DESCRIBED_BY,
                describedByCompData
            },
            [SHIP_TO_HOME_FILTER_START]: {
                filterKey: SHIP_TO_HOME_FILTER_START,
                refinementValue: shipToHomeFilterValue,
                refinementValueDisplayNameComp: SHIP_TO_HOME,
                refinementDisplayNameAndValue: `${value.refinementValueDisplayName}: ${zipCodeText}`,
                refinementValueSpecificDisplayName: zipCodeText,
                checkboxClick: userZipCode ? null : shipToHomeModalTrigger,
                labelClick: shipToHomeModalTrigger,
                pillClick: userZipCode ? shipToHomeCheckboxTrigger : shipToHomeModalTrigger,
                isSelected: isShipToHomeFilterSelected,
                describedById: SHIP_TO_HOME_ARIA_DESCRIBED_BY,
                describedByCompData
            }
        };
        const refinementStringValueIdStart = (value.refinementStringValueId || value.refinementValue || '').split('=')[0];

        return upperFunnelFiltersConfigProperties[refinementStringValueIdStart] || {};
    }

    const enhanceRefinement = value => {
        const addedProperties = upperFunnelFiltersConfig(value) || {};

        return {
            ...value,
            ...addedProperties
        };
    };

    let enhancedRefinements = [];

    const hasUpperFunnelRefinement = data.some(refinement => refinement.type === CHECKBOXES_WITH_DROPDOWN);

    if (!hasUpperFunnelRefinement) {
        return data;
    }

    enhancedRefinements = data.map(refinement => {
        if (refinement.type === CHECKBOXES_WITH_DROPDOWN) {
            const refinementValues = !shouldShowShipToHome ? removeShipToHomeFilter(refinement.values) : refinement.values;
            const enhancedValues = refinementValues.map(enhanceRefinement);
            const enhancedRefinement = {
                ...refinement,
                values: enhancedValues
            };

            return enhancedRefinement;
        }

        return refinement;
    });

    return enhancedRefinements;
}

export default {
    filterParamsStart,
    getUpperFunnelFilterValueStart,
    getPickupFilterValue,
    showStoreSwitcherModal,
    enhanceValues,
    updateFiltersModalState,
    upperFunnelQueue,
    showZipCodeModal,
    upperFunnelCheckboxClick
};
